import React from 'react'
import { ThemeProvider, Container, Row, Col} from 'react-bootstrap'
import LoginForms from '../../Components/Forms/LoginForms';



function Login() {
  return (
    <ThemeProvider
      breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
    >
      <Container fluid>
        <Row>          
          <Col className="login-form min-vh-100 position-relative" md={4}>
            <LoginForms />
          </Col>
          <Col className="img-banner min-vh-100 p-0" md={8}>
            <div className="min-vh-100" style={{ 
              backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/images/login-bg.jpg'})` ,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}>
            </div>
          </Col>
        </Row>
      </Container>
    </ThemeProvider>
  )
}

export default Login